import type { ModelSchema } from '@ember-data/store/types';
import ApplicationSerializer from 'lumen/serializers/application';

export const LATEST = undefined; // Same as REFERENCE_PERIODS

export default class RSSerializableBase extends ApplicationSerializer {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  normalize(
    typeClass: ModelSchema,

    hash: { id: string; latest_entity: string | null },
  ) {
    // Strip the extract date from the ID (format: rssubtype_hotelinfoid,extractdate)
    const indexOfExtractDate = hash.id.lastIndexOf(',');
    const isLatestEntity =
      hash.id.split(',')[1] === LATEST || hash.id.split(',')[1] === '0';
    // Add a reference to the latest entity from the historic entities
    hash.latest_entity = isLatestEntity
      ? null
      : `${hash.id.slice(0, indexOfExtractDate)},0`;

    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
    return super.normalize(typeClass, hash);
  }
}
